import { lazyNamed } from 'src/utils/lazyNamed';

const Accounts = {
  AccountsList: lazyNamed(() => import('./containers/AccountsList'), 'AccountsList'),
  AccountOverview: lazyNamed(() => import('./containers/AccountOverview'), 'AccountOverview'),
};

export default Accounts;
